<template>
  <el-dialog
    :visible.sync="isShow"
    width="7.25rem"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <!-- 点击跳转第三方观看 -->
    <!-- 左侧盒子 -->
    <div class="left-container-1">
      <div class="course_name">课程名称：{{ detailItem.name }}</div>
      <img :src="detailItem.cover" alt="" />
      <el-button class="look-all" @click="viewResources(detailItem.media_link)"
        >开始学习</el-button
      >
    </div>
    <!-- 右侧盒子 -->
    <div class="right-container">
      <!-- 标题 -->
      <!-- <div class="title">
                <p>{{detailItem.name}}</p>
            </div> -->
      <!-- 学生端看到的页面 -->
      <div v-if="type == 'student'" class="student">
        <div class="feel">
          <p>心得感悟：</p>
          <el-input
            type="textarea"
            class="children-feel"
            v-model="detailItem.feeling"
          ></el-input>
          <!-- <el-button class="updateBtn" @click="update" v-else>编辑</el-button> -->
        </div>
        <div class="parentFeel" v-show="false">
          <p>家长心得感悟：</p>
          <el-input
            type="textarea"
            class="parent-feel"
            v-model="detailItem.feeling"
          ></el-input>
        </div>
        <div class="btns" @click="save">
          <div></div>
          <div class="btn">
            <span>保存</span>
          </div>
        </div>
      </div>
      <!-- 教师端看到的页面 -->
      <div v-else-if="type == 'teacher'">
        <div class="study">
          <div class="duration">
            <p>学习时长：</p>
            <el-input
              class="text1"
              v-model="detailItem.period"
              disabled
            ></el-input>
          </div>
          <div class="inspiration">
            <p>学习感悟：</p>
            <el-input
              type="textarea"
              class="text2"
              v-model="detailItem.feeling"
            ></el-input>
          </div>
          <div class="report">
            <p>学习报告：</p>
            <el-input
              type="textarea"
              class="text3"
              v-model="detailItem.report"
            ></el-input>
          </div>
        </div>
        <el-button class="updateBtn" @click="save">保存</el-button>
      </div>
      <!-- 校领导端看到的页面 -->
      <div v-else-if="type == 'principal'">
        <div class="feel">
          <p>校长心得感悟：</p>
          <el-input
            type="textarea"
            class="children-feel"
            v-model="detailItem.feeling"
          ></el-input>
          <el-button class="saveBtn" @click="save">保存</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { saveFeelings } from "../../api/studentApi";
export default {
  name: "VideoDetails",
  props: {
    detailItem: {
      type: Object,
      default: {},
    },
    type: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leaderEmotion: "",
      userId: "",
    };
  },
  watch: {
    type(newVal, old) {
      console.log(this.detailItem);
      console.log(this.type);
      console.log(this.isShow);
    },
  },
  mounted() {
    // }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    // 保存
    save() {
      console.log(this.detailItem);
      console.log(this.userId);
      // return
      let params = {
        role: this.type,
        course_id: this.detailItem.id,
        user_id: JSON.parse(sessionStorage.getItem("userInfo")).roleId,
        feeling: this.detailItem.feeling,
        report: this.detailItem.report,
      };
      saveFeelings(params).then((res) => {
        console.log("保存接口返回值", res);
        this.handleClose();
      });
    },

    //  打开链接
    viewResources(media_link) {
      window.open(media_link);
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  padding: 0.0625rem;
  box-sizing: border-box;
  height: 3.4375rem;

  // justify-content: space-between;
  .el-dialog__header,
  .el-dialog__body {
    padding: 0rem;
  }
  .el-dialog__body {
    padding-top: 0.2222rem;
    display: flex;
  }
  // 个人推荐 详情 左侧部分
  .left-container-1 {
    position: relative;
    margin-right: 0.1528rem;
    display: flex;
    flex-direction: column;
    .course_name {
      height: 0.4514rem;
      font-size: 0.125rem;
      color: #000;
    }
    img {
      height: 2.0556rem;
      cursor: pointer;
    }
    .look-all {
      width: 0.8333rem;
      height: 0.2083rem;
      color: white;
      background-color: #538cf7;
      font-size: 0.0972rem;
      margin-top: 0.2361rem;
      font-size: 0.0833rem;
      border-radius: 0.0694rem;
    }
  }
  // 推荐课程 详情 左侧部分
  .left-container-2 {
    position: relative;
    margin-right: 0.1528rem;
    img {
      width: 4.625rem;
      height: 3.0556rem;
    }
    .look-all {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 1.0139rem;
      height: 0.3333rem;
      color: #d9221a;
      // border: 1px solid #D9221A;
      background: white;
      font-size: 0.0972rem;
    }
    .look-all:hover {
      background: rgba(217, 34, 26, 0.2);
    }
  }
  .right-container {
    // border: 1px solid red;
    width: 3.2222rem;
    box-sizing: border-box;
    padding-top: 0.2778rem;
    .student {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // border: 1px solid red;
      height: 100%;
    }
    .feel,
    .parentFeel {
      p {
        // margin-bottom: .0556rem;
        font-size: 0.0972rem;
        font-weight: bold;
        color: black;
      }
      .children-feel,
      .parent-feel {
        .el-textarea__inner {
          font-size: 0.0833rem;
          height: 1.0417rem;
          // background: rgb(230,230,230);
          // color: #4c4c4c;
          border: 1px solid rgba(216, 224, 240, 1);
          padding: 0.0694rem;
        }
      }
      .updateBtn {
        margin-top: 0.0556rem;
        padding: 0rem;
        width: 0.3611rem;
        height: 0.2222rem;
        color: #d9221a;
        border-radius: 0.0208rem;
        border: 1px solid #d9221a;
        background: white;
        font-size: 0.0972rem;
      }
    }
    .btns {
      display: flex;
      justify-content: space-between;
      margin-top: 0.1389rem;
      .btn {
        span {
          color: #608def;
          font-size: 0.0833rem;
          cursor: pointer;
          user-select: none;
        }
      }
    }
    .parentFeel {
      // margin-top: .1389rem;
    }
    // 教师端 我要学习 详情右侧部分样式
    .study {
      p {
        margin-bottom: 0.0556rem;
        font-size: 0.0972rem;
        font-weight: bold;
        color: black;
      }
      .text1,
      .text2,
      .text3 {
        margin-bottom: 0.1528rem;
        .el-input__inner {
          font-size: 0.0833rem;
          background: rgb(230, 230, 230);
        }
        .el-textarea__inner {
          font-size: 0.0833rem;
          background: rgb(230, 230, 230);
          padding: 0rem;
          color: #4c4c4c;
        }
      }
      .text1 {
        .el-input__inner {
          padding: 0rem;
          height: 0.2222rem;
        }
      }
      .text2 {
        .el-textarea__inner {
          height: 0.4444rem;
        }
      }
      .text3 {
        .el-textarea__inner {
          height: 0.375rem;
        }
      }
    }
    .updateBtn {
      // position: absolute;
      left: 0;
      bottom: 0.0347rem;
      padding: 0rem;
      width: 0.3611rem;
      height: 0.2222rem;
      color: #d9221a;
      border-radius: 0.0208rem;
      border: 1px solid #d9221a;
      background: white;
      font-size: 0.0972rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reuse/RecommendDetails.vue